import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs';
import { TipoNovedad } from '../domain/tipo-novedad';

@Injectable({
  providedIn: 'root'
})
export class TipoNovedadService {
  urlTipoNovedad: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(
    public httpClient: HttpClient
  ) {
    this.urlTipoNovedad = GLOBAL.URL_BASE+'sicaTipoNovedad';
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-30
   * Busca los tipos de novedad activos ordenados por su descripción
   */
  findAllTipoNovedadesActivosOrderByDescripcionAsc():Observable<any>{
    return this.httpClient.get(this.urlTipoNovedad+'/findAllTipoNovedadesActivosOrderByDescripcionAsc');
  }

   /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-31
   * @param id
   * Busca un TipoNovedad dado un id
   */
  getSicaTipoNovedadGenericResponse(id:number):any{
    return this.httpClient.get(this.urlTipoNovedad+'/getSicaTipoNovedadGenericResponse/'+id);
  }

  getDataTipoNovedad() : any {
    return this.httpClient.get(this.urlTipoNovedad+'/getTiposNovedad/');
  }

  saveTipoNovedad(tipoNovedad:TipoNovedad) : any{
    return this.httpClient.post(this.urlTipoNovedad+'/saveTipoNovedad/', tipoNovedad, this.httpOptions);
  }

  updateTipoNovedad(tipoNovedad:TipoNovedad) : any{
    return this.httpClient.put(this.urlTipoNovedad+'/updateTipoNovedad/', tipoNovedad, this.httpOptions);
  }
  
}
